import React, { useState, useRef, useEffect } from "react";
import { MobileMainMenuProps, MenuItem } from "./types";
import { ListItems } from "./ListItems";

export const MobileMainMenu: React.VFC<MobileMainMenuProps> = ({
    menuItems,
    parentItem,
    startPageId,
    currentPageId,
    logotypeSettings,
    searchSettings,
    toolNavigationHtml,
    chevronIconSvg,
    searchIconSvg,
    hasLogotype,
    isintra,
    organizations,

}) => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>();
    const [isSearchPanelOpen, setIsSearchPanelOpen] = useState<boolean>();
    const [activeMenuPage, setActiveMenuPage] = useState(parentItem);
    const [currentMenuItems, setCurrentMenuItems] = useState(menuItems);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const defaultText = "Välj förvaltning";


    // Hämta tidigare sparad text från localStorage eller använd standard
    const [selectedOption, setSelectedOption] = useState(() => {
        if (typeof window !== "undefined") {
            return localStorage.getItem("selectedDropdownText") || defaultText;
        }
        return defaultText;
    });
    let isLoadingPages = false;
    const openCloseMenuButtonRef: React.RefObject<HTMLButtonElement> =
        useRef(null);

    useEffect(() => {
        const element = document.querySelector('.intra-header-content__personlink') as HTMLElement;
        if (element && element.innerText.trim() !== '') {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }

        const handleCloseMenu = (event: KeyboardEvent) => {
            if (event.key == "Escape") {
                if (isMenuOpen) onOpenMainMenuClick({});
                if (isSearchPanelOpen) onOpenSearchPanelClick({});
            }
        };

        document.addEventListener("keyup", handleCloseMenu);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("keyup", handleCloseMenu);
        };

      
    }, [isMenuOpen, isSearchPanelOpen, isLoggedIn ]);
    const handleSelect = (text: string, url:string) => {
        console.log("handleSelect körs med:", text);
        setSelectedOption(text)
        setIsOpen(!isOpen)
        if (typeof window !== "undefined") {
            localStorage.setItem("selectedDepartment", text);
        }
    
        if (url) {
            window.location.href = url; // Navigera till URL
        }
    };

    const onOpenMainMenuClick = (event: any) => {
        // Tar bort vertikal scroll på sidan när menyn är öppen
        document.documentElement.classList.toggle("overflow-hidden");
        setIsMenuOpen((current) => !current);
        setIsSearchPanelOpen(false);
    };

    const onOpenSearchPanelClick = (event: any) => {
        setIsSearchPanelOpen((current) => !current);
    };

    async function onMenuNavigationClick(
        event: any,
        action: string,
        clickedItem: MenuItem
    ) {
        event.preventDefault();

        const fetchForPageId =
            action === "next" ? clickedItem.pageId : clickedItem.parentPageId;

        if (isLoadingPages) {
            console.log("Hämtar menyalterantiv...");
            return;
        }

        isLoadingPages = true;

        await fetch(
            "/api/fetchmenuitems?" +
            new URLSearchParams({
                pageId: fetchForPageId.toString(),
                currentPageId: currentPageId.toString(),
                langName: clickedItem.langName,
            })
        )
            .then((response) => response.json())
            .then((nextMenuItem: MobileMainMenuProps) => {
                setCurrentMenuItems(nextMenuItem.menuItems);
                clickedItem.isNonClickableInMobile = nextMenuItem.parentItem.isNonClickableInMobile
                const activeItem =
                    action === "next" ? clickedItem : nextMenuItem.parentItem;

                setActiveMenuPage(activeItem);

                isLoadingPages = false;
            })
            .catch((error: Error) => {
                isLoadingPages = false;
                console.error("Error:", error);
            });
    }

    function Logotype() {
        let hasHeader: boolean =
            logotypeSettings.header !== null && logotypeSettings.header !== "";
        let hasCustomLogotype: boolean =
            logotypeSettings.imageUrl !== null && logotypeSettings.imageUrl !== "";

        return (
            <>
                {!isintra ? (
                    <div className="logotype">
                        <a
                            className="logotype__mobile dark ignore-readability-rule"
                            href={logotypeSettings.targetHref}
                            aria-label={logotypeSettings.screenReaderLinkTextAriaLabel}
                        >
                            {/* Visa enbart logotyp här om sitenamn inte är angivet. Annars visas logotypen ovanför navigeringen. */}
                            {(() => {
                                if (!hasHeader && hasCustomLogotype) {
                                    return (
                                        <>
                                            <div
                                                className={`logotype__default ${logotypeSettings.customOrganizationCssClass}`}
                                            >
                                                <img
                                                    src={logotypeSettings.imageUrl}
                                                    alt={logotypeSettings.imageAltText}
                                                />
                                            </div>
                                            <span className="visually-hidden">
                                                {logotypeSettings.screenReaderLinkTextGeneric}
                                            </span>
                                        </>
                                    );
                                } else if (hasHeader) {
                                    return (
                                        <div>
                                            <span>{logotypeSettings.header}</span>
                                        </div>
                                    );
                                } else if (!logotypeSettings.hideDefaultLogotype) {
                                    return (
                                        <>
                                            <div
                                                className={`logotype__default ${logotypeSettings.customOrganizationCssClass}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: logotypeSettings.defaultLogotypeSvg,
                                                }}
                                            ></div>
                                            <span className="visually-hidden">
                                                {logotypeSettings.screenReaderLinkTextGeneric}
                                            </span>
                                        </>
                                    );
                                }
                              
                            })()}
                        </a>
                    </div>
                ) : (
                    <div className="megamenu__home-wrapper">
                        <div className="megamenu__department">
                            <label htmlFor="department-select-mobile" className="megamenu__department__label megamenu__department__label--mobile"> Insidan</label>
                            <div className="megamenu__department__dropdown megamenu__department__dropdown--mobile ">
                                <button className="megamenu__department__dropdown-btn megamenu__department__dropdown-btn--mobile" id="dropdown-btn-mobile"
                                   onClick={() => setIsOpen(!isOpen)}>
                                    <span> {selectedOption}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path fillRule="evenodd" clipRule={"evenodd"}
                                            d="M11.68 2.96765C11.9504 3.23962 11.9504 3.68058 11.68 3.95255L6.7327 8.92934C6.6363 9.02645 6.5218 9.1035 6.39576 9.15608C6.26973 9.20864 6.13463 9.2357 5.9982 9.2357C5.86176 9.2357 5.72667 9.20864 5.60063 9.15608C5.47459 9.1035 5.3601 9.02645 5.2637 8.92934L0.316354 3.95255C0.0459909 3.68058 0.0459909 3.23962 0.316354 2.96765C0.586716 2.69568 1.02506 2.69568 1.29542 2.96765L5.9982 7.69842L10.701 2.96765C10.9713 2.69568 11.4097 2.69568 11.68 2.96765Z"
                                            fill="white" />
                                    </svg>
                                </button>

                                {isOpen && (
                                    <ul className="megamenu__department__dropdown-list show" id="dropdown-list-mobile">
                                       
                                        {organizations?.map((item) => (
                                            <li
                                                key={item.href}
                                                className="megamenu__department__dropdown-item"
                                                data-url={item.href}
                                                onClick={() => handleSelect(item.text, item.href)}
                                            >
                                                {item.text}
                                            </li>
                                        ))}
                                    </ul>
                                )}


                            </div>

                        </div>
                    </div>
                )}
            </>
        );
    }


    function SearchPanel() {
        const hiddenSearchParameters = searchSettings.searchParameters.map(
            (tuple, index) => (
                <input
                    type="hidden"
                    key={index}
                    name={tuple.item1}
                    value={tuple.item2}
                />
            )
        );

        return (
            <div
                id="mobile-search-panel "
                className={`mobile-main-menu__search-panel mobile-container`}
            >
                <form
                    action={searchSettings.searchPageUrl}
                    method="get"
                    role="search"
                    autoComplete="off"
                    className="global-search intra-header-content__search mobile-search"
                >
                    <div className="global-search__search-box-button-container mobile-search__box-button-container">
                        {hiddenSearchParameters}

                        <input
                            type="hidden"
                            name="theme"
                            value={searchSettings.primaryColorName}
                        />
                        <label className="visually-hidden" htmlFor="search-input-mobile">
                            {searchSettings.label}
                        </label>
                        <input
                            type="search"
                            name="q"
                            placeholder={searchSettings.inputPlaceholderText}

                            className="mobile-search__field"
                        />
                        <button type="submit" className="mobile-search__button">
                            <span className="visually-hidden">Sök</span>
                            <img
                                aria-hidden="true"
                                src="/icons/visuell-identitet/search.svg"
                                alt=""
                            />
                        </button>
                    </div>
                    <div id="mobile-autocomplete-result" className="hidden visually-hidden autocomplete mobile-autocomplete-result">

                        <div id="mobile-result-topdiv" className="autocomplete__content mobile-result-topdiv">

                        </div>
                        <div id="mobile-result-bottomdiv" className="autocomplete__content mobile-result-bottomdiv ">

                        </div>
                    </div>
                </form>
            </div>
        );
    }

    return (
        <nav
            className={
                "mobile-main-menu container-fluid p-0 m-0 " +
                (isMenuOpen || isSearchPanelOpen ? "mobile-main-menu--open" : "")
            }
        >
            <div
                data-menu-open={isMenuOpen ? "true" : "false"}
                data-search-panel-open={isSearchPanelOpen ? "true" : "false"}
            ></div>

            <div className="mobile-main-menu__header">
                {isMenuOpen &&
                    activeMenuPage &&
                    startPageId !== activeMenuPage.pageId ? (
                    <>
                        <button
                            type="button"
                            className="mobile-main-menu__previous-navigation link-focus dark"
                            aria-label={`Visa undersidor till ${activeMenuPage.text}`}
                            dangerouslySetInnerHTML={{ __html: chevronIconSvg }}
                            onClick={(e) => {
                                activeMenuPage;
                                onMenuNavigationClick(e, "previous", activeMenuPage);
                            }}
                        ></button>
                        {!activeMenuPage.isNonClickableInMobile ? (<>
                            <a href={activeMenuPage.href} className="dark dark-text">
                                {activeMenuPage.text}
                            </a>
                        </>) : (<>
                            <span className="dark dark-text">
                                {activeMenuPage.text}
                            </span>
                        </>)}

                    </>
                ) : (
                    <Logotype />
                )}
                {currentMenuItems.length > 0 ? (<>
                    <div className="mobile-main-menu__navigation-bar">

                        <div
                            className={`mobile-main-menu__search-button ${isMenuOpen ? "d-none" : ""
                                }`}
                        >
                            <button
                                className="link-focus dark"
                                aria-controls="mobile-search-panel"
                                aria-expanded={isSearchPanelOpen ? "true" : "false"}
                                onClick={onOpenSearchPanelClick}
                            >
                                <span
                                    dangerouslySetInnerHTML={{ __html: searchIconSvg }}
                                ></span>
                                <span>{isSearchPanelOpen ? "Stäng" : "Sök"}</span>
                            </button>
                        </div>
                        <div className="mobile-main-menu__menu-button">
                            <button
                                ref={openCloseMenuButtonRef}
                                className="link-focus dark"
                                aria-controls="mobile-menu-content"
                                aria-expanded={isMenuOpen ? "true" : "false"}
                                onClick={onOpenMainMenuClick}
                                data-testid="mobilemenubtn"
                            >
                                <span className="mobile-main-menu__burger">
                                    <span className="mobile-main-menu__burger-one"></span>
                                    <span className="mobile-main-menu__burger-two"></span>
                                    <span className="mobile-main-menu__burger-three"></span>
                                </span>
                                <span>{isMenuOpen ? "Stäng" : "Meny"}</span>
                            </button>
                        </div>

                    </div></>) : (<></>)}
            </div>

            <SearchPanel />

            <div
                id="mobile-menu-content"
                tabIndex={
                    -1
                } /* This prevents tab focus for elements with "overflow:scroll" on Firefox */
                className={`mobile-main-menu__content ${isintra && isMenuOpen &&
                    activeMenuPage &&
                    startPageId !== activeMenuPage.pageId ? "more-space" : ""} ${hasLogotype ? "mobile-main-menu__content--with-logotype" : ""
                    } ${isLoggedIn ? "mobile-main-menu__content--with-inlogg" : ""} `}
            >
                <div className="mobile-main-menu__menu-items"
                    data-testid="mobilemenucontent"
                >
                    <ListItems
                        menuItems={currentMenuItems}
                        chevronIconSvg={chevronIconSvg}
                        onMenuNavigationClick={onMenuNavigationClick}
                        activeMenuPage={activeMenuPage}
                        startPageId={startPageId}
                    />
                </div>
                <div dangerouslySetInnerHTML={{ __html: toolNavigationHtml }} />
            </div>
        </nav>
    );
};
